export interface CorPartido {
  /** Cor do partido (selo, barra, painel da foto). */
  fundo: string;
  /** Cor do texto sobre `fundo`. */
  texto: string;
  /** Variante legível sobre branco (percentual); igual a `fundo` salvo cores claras. */
  sobreBranco: string;
}

type CorBase = Omit<CorPartido, 'sobreBranco'> & { sobreBranco?: string };

/** Cor neutra (azul-marinho do painel) para sigla desconhecida. */
export const COR_PARTIDO_PADRAO: CorPartido = { fundo: '#1e3a8a', texto: '#ffffff', sobreBranco: '#1e3a8a' };

// Cores aproximadas da identidade de cada sigla (selo e barra do cartão). Sigla fora da lista cai no padrão.
const CORES: Record<string, CorBase> = {
  PT: { fundo: '#d9141f', texto: '#ffffff' },
  PL: { fundo: '#1f56b5', texto: '#ffffff' },
  PSD: { fundo: '#0a9bd8', texto: '#ffffff' },
  NOVO: { fundo: '#f26b1d', texto: '#ffffff' },
  DC: { fundo: '#1f9d55', texto: '#ffffff' },
  PCB: { fundo: '#b30f1f', texto: '#ffffff' },
  PSTU: { fundo: '#9b1c1c', texto: '#ffffff' },
  AVANTE: { fundo: '#e8590c', texto: '#ffffff' },
  UP: { fundo: '#c2185b', texto: '#ffffff' },
  DEMOCRATA: { fundo: '#0b6bb8', texto: '#ffffff' },
  MISSAO: { fundo: '#f5c400', texto: '#1a1a1a', sobreBranco: '#a67c00' },
  PCO: { fundo: '#c40000', texto: '#ffffff' },
  PSB: { fundo: '#f5b800', texto: '#1a1a1a', sobreBranco: '#a67c00' },
  PDT: { fundo: '#c8102e', texto: '#ffffff' },
  PSOL: { fundo: '#ffcc00', texto: '#1a1a1a', sobreBranco: '#a67c00' },
  MDB: { fundo: '#2e8b57', texto: '#ffffff' },
  PSDB: { fundo: '#0080ff', texto: '#ffffff' },
  PP: { fundo: '#4a90d9', texto: '#ffffff' },
  UNIAO: { fundo: '#1b3f8b', texto: '#ffffff' },
  REPUBLICANOS: { fundo: '#2b7bb9', texto: '#ffffff' },
  PODE: { fundo: '#1fa35c', texto: '#ffffff' },
  PV: { fundo: '#2e9e44', texto: '#ffffff' },
  REDE: { fundo: '#2cb67d', texto: '#ffffff' },
  CIDADANIA: { fundo: '#e83e8c', texto: '#ffffff' },
};

function normalizarSigla(sigla: string): string {
  return sigla
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .replace(/[^A-Za-z]/g, '')
    .toUpperCase();
}

/** Cor do partido pela sigla do TSE (ex.: "PT", "MISSÃO"); desconhecido → padrão do painel. */
export function corPartido(sigla: string | null | undefined): CorPartido {
  if (!sigla) return COR_PARTIDO_PADRAO;
  const base = CORES[normalizarSigla(sigla)];
  return base ? { ...base, sobreBranco: base.sobreBranco ?? base.fundo } : COR_PARTIDO_PADRAO;
}
